import { render } from "./ModalSoalPreview.vue?vue&type=template&id=f7afa762&scoped=true"
import script from "./ModalSoalPreview.vue?vue&type=script&lang=js"
export * from "./ModalSoalPreview.vue?vue&type=script&lang=js"

import "./ModalSoalPreview.vue?vue&type=style&index=0&id=f7afa762&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7afa762"]])

export default __exports__